import { DialogComponent } from '@theme/dialog';

/** Adds lazy video loading and playback cleanup to the theme's existing dialog. */
class FigmaGiftTutorial extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    this.refs.dialog.addEventListener('close', this.#pauseVideo);
  }

  showDialog() {
    const player = this.querySelector('.figma-gift-includes__tutorial-player');
    const template = this.querySelector('template');

    if (!player.querySelector('video')) {
      player.append(template.content.cloneNode(true));
    }

    super.showDialog();
  }

  #pauseVideo = () => {
    this.querySelector('video')?.pause();
  };

  disconnectedCallback() {
    this.#pauseVideo();
    this.refs.dialog.removeEventListener('close', this.#pauseVideo);
    this.refs.dialog.close();

    // A removed theme-editor section cannot send its toggle event to document.
    if (!document.querySelector('dialog[open][scroll-lock], details[open][scroll-lock]')) {
      document.documentElement.removeAttribute('scroll-lock');
    }

    super.disconnectedCallback();
  }
}

if (!customElements.get('figma-gift-tutorial')) {
  customElements.define('figma-gift-tutorial', FigmaGiftTutorial);
}
